import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Field extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "type", Model.attribute('type'));
    _defineProperty(this, "validation", Model.attribute('validation'));
    _defineProperty(this, "required", Model.attribute('required'));
    _defineProperty(this, "icon", Model.attribute('icon'));
    _defineProperty(this, "sort", Model.attribute('sort'));
    _defineProperty(this, "deleted_at", Model.attribute('deleted_at', Model.transformDate));
    _defineProperty(this, "answer", Model.hasOne('answer'));
    _defineProperty(this, "on_bio", Model.attribute('on_bio'));
  }
  apiEndpoint() {
    return '/masquerade-fields' + (this.exists ? `/${this.id()}` : '');
  }
}
flarum.reg.add('fof-masquerade', 'lib/models/Field', Field);